import { render } from "./apply.vue?vue&type=template&id=55b8e13a&scoped=true"
import script from "./apply.vue?vue&type=script&lang=js"
export * from "./apply.vue?vue&type=script&lang=js"

import "./apply.vue?vue&type=style&index=0&id=55b8e13a&lang=less&scoped=true"
import "./apply.vue?vue&type=style&index=1&id=55b8e13a&lang=less"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b8e13a"]])

export default __exports__